"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateEditChannelArgs = exports.cleanChannelName = exports.parseChannel = void 0;
const lodash_1 = require("lodash");
const parseChannel = (channel) => (Object.assign(Object.assign({}, channel), { createdAt: new Date(channel.createdAt) }));
exports.parseChannel = parseChannel;
const cleanChannelName = (name) => name.trim().toLowerCase().replace(/ /g, "_");
exports.cleanChannelName = cleanChannelName;
const calculateEditChannelArgs = (originalChannel, newChannel) => {
    const args = {};
    if (!(0, lodash_1.isEqual)(newChannel.buildTypes, originalChannel.buildTypes)) {
        args.buildTypes = newChannel.buildTypes;
    }
    Object.keys(newChannel.builds).forEach((deviceType) => {
        const build = newChannel.builds[deviceType];
        const oldBuild = originalChannel.builds[deviceType];
        if (build && oldBuild && (build.id !== oldBuild.id)) {
            args.builds = Object.assign({}, args.builds);
            args.builds[deviceType] = build.id;
        }
        if (build && oldBuild === undefined) {
            args.builds = Object.assign({}, args.builds);
            args.builds[deviceType] = build.id;
        }
    });
    Object.keys(originalChannel.builds).forEach((deviceType) => {
        const build = newChannel.builds[deviceType];
        if (build === undefined) {
            args.builds = Object.assign({}, args.builds);
            args.builds[deviceType] = null;
        }
    });
    return args;
};
exports.calculateEditChannelArgs = calculateEditChannelArgs;
//# sourceMappingURL=Channels.js.map